import { siteStats } from "@/mocks/home";

export default function Stats() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-50">
          {siteStats.map((stat) => (
            <div key={stat.label} className="px-5 py-6 md:px-7 md:py-7">
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {stat.value}
                <span className="ml-1 text-xs font-normal text-foreground-500">{stat.unit}</span>
              </p>
              <p className="mt-2 flex items-center gap-1.5 text-xs md:text-sm text-foreground-600">
                <i className="ri-bar-chart-2-line text-secondary-500" />
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}